import React from 'react';
import { Container } from 'reactstrap';
import TeamUserDashDropdown from 'containers/TeamUserDashDropdown';
import PageHeader from 'containers/PageHeader';
import UserEventList from 'containers/UserEventList';

const UserDashPage = () => {
  if (document.title !== 'Studio') document.title = 'Studio';
  return (
    <Container fluid>
      <PageHeader
        title={<TeamUserDashDropdown />}
        subtitle="User dashboard"
        borderBottom={true}
      />
      <UserEventList />
    </Container>
  );
};

export default UserDashPage;
